<template>
  <div>
    <h2>Rooms</h2>
    <v-layout row class="house__selected-rooms ml-0 mr-0">
      <template v-if="selectedHouse.room.length > 0">
        <v-expansion-panel class="elevation-0">
          <v-expansion-panel-content
            v-for="(room, i) in selectedHouse.room"
            :key="i"
          >
            <template v-slot:header>
              <div>{{ room.name }}</div>
            </template>
            <v-list v-if="room.areas.length > 0" dense>
              <v-list-tile v-for="(area, index) in room.areas" :key="index">
                <v-list-tile-content>
                  <v-list-tile-title
                    class="body-1"
                    v-text="area.area"
                  ></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>
      <template v-else>
          <v-layout row wrap>
            <v-flex shrink>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn flat icon color="primary" @click.stop="installDefaultRooms(selectedHouse.id)" v-on="on">
                    <v-icon class="mr-1">create</v-icon>
                  </v-btn>
                </template>
                <span>Install Default Rooms</span>
              </v-tooltip>
            </v-flex>
          </v-layout>

      </template>

    </v-layout>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DetailsRooms',
  computed: {
    ...mapGetters({
      selectedHouse: 'HouseList/getSelectedHouse'
    })
  },
  methods: {
    ...mapActions({
      installDefaultRooms: 'HouseList/installDefaultRooms'
    })
  }
}
</script>
